/* Calypso redesign — product page enhancements.
   Makes the section-store "Excellent ... happy writers" review-summary block
   (a shadow-DOM web component, not Judge.me) clickable so it smooth-scrolls to
   the Judge.me review widget further down the same page. */
(function () {
  if (window.__calypsoPdpInit) return;
  window.__calypsoPdpInit = true;

  function reviewsTarget() {
    /* prefer the full reviews display / cards carousel; skip the small snippet
       badge that sits up in the buy column (that's where the click came from). */
    return document.querySelector('#judgeme_product_reviews')
      || document.querySelector('.jdgm-rev-widg:not(.jdgm-review-snippet-widget)')
      || document.querySelector('.jdgm-cards-carousel')
      || document.querySelector('.jdgm-widget:not(.jdgm-review-snippet-widget)')
      || document.querySelector('.jdgm-widget');
  }

  function isSummaryHost(node) {
    return node && node.tagName && /review-summary/i.test(node.tagName);
  }

  /* Swap the section-store summary block's SVG star-paths for the brand chaton
     jewel (matches the home reviews + the Judge.me diamonds). The block renders
     each star as an inline <svg> in an open shadow root: full = solid fill,
     half = a <linearGradient>, empty = a lighter solid fill. */
  var JEWEL = 'M7 5L17 5L21 9.5L12 20.5L3 9.5Z';
  var TEAL = '#00676b', FADED = 'rgba(0,103,107,.22)';
  var cjwSeq = 0;
  function jewelifySummaryStars() {
    document.querySelectorAll('*').forEach(function (host) {
      if (!isSummaryHost(host) || !host.shadowRoot) return;
      var svgs = host.shadowRoot.querySelectorAll('.stars svg');
      if (!svgs.length) return;
      /* reference "full" fill = the first solid (non-gradient) star's fill */
      var fullFill = null;
      svgs.forEach(function (svg) {
        if (svg.querySelector('linearGradient')) return;
        var f = svg.querySelector('[fill]');
        if (f && !fullFill) fullFill = (f.getAttribute('fill') || '').toLowerCase();
      });
      svgs.forEach(function (svg) {
        if (svg.dataset.cjewel) return;
        var hasGradient = !!svg.querySelector('linearGradient');
        var f = svg.querySelector('[fill]');
        var thisFill = f ? (f.getAttribute('fill') || '').toLowerCase() : null;
        var defs = '', fill;
        if (hasGradient) {
          var id = 'cjw-h-' + (cjwSeq++);
          fill = 'url(#' + id + ')';
          defs = '<defs><linearGradient id="' + id + '" x1="0" x2="1" y1="0" y2="0">'
               + '<stop offset="50%" stop-color="' + TEAL + '"/>'
               + '<stop offset="50%" stop-color="' + FADED + '"/></linearGradient></defs>';
        } else if (thisFill && fullFill && thisFill === fullFill) {
          fill = TEAL;   /* full */
        } else {
          fill = FADED;  /* empty */
        }
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.innerHTML = defs + '<path d="' + JEWEL + '" fill="' + fill + '"/>';
        svg.dataset.cjewel = '1';
      });
    });
  }

  /* cursor affordance on the summary block(s) */
  function markClickable() {
    document.querySelectorAll('*').forEach(function (el) {
      if (isSummaryHost(el) && el.style.cursor !== 'pointer') {
        el.style.cursor = 'pointer';
        el.setAttribute('role', 'link');
        el.setAttribute('tabindex', '0');
        el.setAttribute('title', 'Read the reviews');
      }
    });
  }
  function enhanceSummary() { markClickable(); jewelifySummaryStars(); }
  if (document.readyState !== 'loading') enhanceSummary();
  else document.addEventListener('DOMContentLoaded', enhanceSummary);
  /* the app block hydrates late and can re-render — re-apply for a short while */
  var ticks = 0;
  var iv = setInterval(function () { enhanceSummary(); if (++ticks > 24) clearInterval(iv); }, 500);

  function jumpToReviews(e) {
    var path = (e.composedPath && e.composedPath()) || [];
    var host = path.find(isSummaryHost);
    if (!host) return;
    var target = reviewsTarget();
    if (!target) return; /* no Judge.me widget on this page → do nothing */
    e.preventDefault();
    /* Instant jump to the reviews. (smooth behavior is a no-op in this theme
       context — reduced-motion / scroll-behavior — so jump reliably instead.)
       scroll-margin-top clears the sticky Calypso header. */
    target.style.scrollMarginTop = '90px';
    target.scrollIntoView({ block: 'start' });
  }
  /* capture phase: the web component can stopPropagation on its own click, so
     bubble-phase document listeners may never see it. */
  document.addEventListener('click', jumpToReviews, true);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && isSummaryHost(document.activeElement)) {
      jumpToReviews({ composedPath: function () { return [document.activeElement]; }, preventDefault: function () { e.preventDefault(); } });
    }
  });
})();
